/// <reference path='../_all.ts' />


module user {
   /**
    * Angular Service http://stackoverflow.com/questions/19447886/how-can-i-define-an-angularjs-service-using-a-typescript-class-that-doesnt-poll
    */
   export class UserService {
      static $inject = [
         '$http',
         'CacheFactory',
         '$q',
         '$rootScope',
      ];

      constructor(
         // Add the parameter and type definition.
         public $http: ng.IHttpService,
         private CacheFactory: CacheFactory.ICacheFactory,
         private $q: ng.IQService,
         private $rootScope: ng.IRootScopeService
      ) { }

      public login(data: LoginData, returnUrl: string): ng.IHttpPromise<{ Success: boolean, ReturnUrl: string }> {

         return this.$http<boolean>({
            method: "POST"
            , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/User/Login/"
            , headers: { 'Content-Type': 'application/json' }
            , params: {
               username: data.email,
               persist: !!data.persist,
               returnUrl: returnUrl
            }
            , data: '\'' + data.password + '\''
         }).then((response: { data: any }): any => { //success
            this.CacheFactory.destroyAll();
            return response;
         })
            .catch((response) => {
               throw "Error in 'UserService.login' " + response.status;
            });

      }



      public intranetLogin(returnUrl: string): ng.IHttpPromise<{ Success: boolean, ReturnUrl: string }> {

         return this.$http<boolean>({
            method: "GET"
            , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/User/IntranetLogin/"
            , headers: { 'Content-Type': 'application/json' }
            , params: {
               returnUrl: returnUrl
            }
         }).then((response: { data: any }): any => { //success           
            this.CacheFactory.destroyAll();
            return response;
         })
            .catch((response) => {
               throw "Error in 'UserService.intranetLogin' " + response.status;
            });

      }



      public resetPassword(username: string): ng.IHttpPromise<boolean> {

         return this.$http<boolean>({
            method: "POST"
            , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/User/ResetPassword/"
            , headers: { 'Content-Type': 'application/json' }
            , params: {
               username: username
            }
         }).then((response: { data: boolean }): any => { //success
            return response;
         })
            .catch((response) => {
               throw "Error in 'UserService.resetPassword' " + response.status;
            });

      }



      public changePassword(pwdOld: string, pwdNew: string): ng.IHttpPromise<void> {

         return this.$http<void>({
            method: "POST"
            , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/User/ChangePassword/"
            , headers: { 'Content-Type': 'application/json' }
            , params: {
               passwordOld: pwdOld,
               passwordNew: pwdNew,
            }
         });
      }


      public logout(): ng.IHttpPromise<void> {

         this.CacheFactory.destroyAll();

         return this.$http<void>({
            method: "GET"
            , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/User/Logout/"
            , headers: { 'Content-Type': 'application/json' }
         }).then((response: { data: void }): any => { //success
            return response;
         })
            .catch((response) => {
               throw "Error in 'UserService.logout' " + response.status;
            });

      }

      public register(data: RegisterData): ng.IHttpPromise<FormSrvErrorCollection> {
         return this.$http<FormSrvErrorCollection>({
            method: "POST"
            , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/User/Register/"
            , headers: { 'Content-Type': 'application/json' }
            , data: data
         }).then(
            (response: { data: FormSrvErrorCollection }): any => { //success
               return response;
            })
            .catch((response) => {
               throw "Error in 'UserService.register' " + response.status;
            });
      }



      public isValidUsername(username: string): ng.IHttpPromise<FormSrvErrorCollection> {

         return this.$http<FormSrvErrorCollection>({
            method: "GET"
            , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/User/IsValidUsername/"
            , headers: { 'Content-Type': 'application/json' }
            , params: {
               "username": username,
            }
         }).then((response: { data: FormSrvErrorCollection }): any => { //success
            return response;
         })
            .catch((response) => {
               throw "Error in 'UserService.isValidUsername' " + response.status;
            });

      }

      public checkNsEMail(email: string, verteilerid: string): ng.IHttpPromise<number> {

         return this.$http<number>({
            method: "GET"
            , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/User/CheckNsEMail/"
            , headers: { 'Content-Type': 'application/json' }
            , params: {
               "email": email,
               "verteilerid": verteilerid
            }
         }).then((response: { data: number }): any => { //success 
            return response;
         })
            .catch((response) => {
               throw "Error in 'UserService.checkNsEMail' " + response.status;
            });

      }

      public upsertNewsletterProfile(data: NewsletterProfileData): ng.IHttpPromise<NewsletterProfileData> {

         return this.$http<NewsletterProfileData>({
            method: "POST"
            , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/User/UpsertNewsletterProfile/"
            , headers: { 'Content-Type': 'application/json' }
            , data: data
         }).then((response: { data: NewsletterProfileData }): any => { //success
            return response;
         })
            .catch((response) => {
               throw "Error in 'UserService.upsertNewsletterProfile' " + response.status;
            });

      }

      public isLoggedIn() {
         return pglob.RouteData.User != null;
      }



      public getJwtToken(): ng.IPromise<string> {


         var deferred = this.$q.defer<string>();

         if (this.$rootScope['jwt'] && !this.isTokenExpired(this.$rootScope['jwt'])) {
            deferred.resolve(this.$rootScope['jwt']);
            return deferred.promise;
         }

         this.$http<string>({
            method: "GET"
            , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/User/GetJwtToken/"
            , headers: { 'Content-Type': 'application/json' }
         }).then((response: { data: string }): any => { //success 
            this.$rootScope['jwt'] = response.data;
            deferred.resolve(response.data);
         })
            .catch((response) => {
               throw "Error in 'UserService.getJwtToken' " + response.status;
            });

         return deferred.promise;

      }

      public getBearer(token: string): object {
         let header = {};
         if (token != null) { //not anonymous
            header = { 'Authorization': 'Bearer ' + token };
         }
         return header;
      }

      private isTokenExpired(token: string): boolean {
         const expiration = this.getJWTExpireDate(token);
         if (!expiration) return true; //if expiration not readable => expired
         return (new Date()) >= expiration;
      }

      private getJWTExpireDate(jwtToken: string): Date {
         if (jwtToken) {
            try {
               const [, payload] = jwtToken.split('.');
               const { exp: expires } = JSON.parse(window.atob(payload));
               if (typeof expires === 'number') {
                  return new Date(expires * 1000);
               }
            } catch {
               // ignore
            }
         }
         return null;
      }
   }

}
